import { isEmpty } from "lodash";

import { ADVERTISER_ID_COLUMN } from "../../config/constants";
import type { Dimension, DimensionTemplates } from "../../types/dimensions";
import { DimensionTypes, DimensionInitIgnore } from "../../types/dimensions";

import type { DropdownDimensionConfiguration } from "./DropdownDimension";

export const getDimensionIds = (
    dimensionsSection: DimensionTemplates[][],
): Dimension[] => {
    const dimensions: Dimension[] = [];
    for (const section of dimensionsSection) {
        for (const dimensionDefinition of section) {
            const isValidDimensionType = Object.values(DimensionTypes).includes(
                dimensionDefinition.type,
            );
            const isIncludeDimensionType = !DimensionInitIgnore.includes(
                dimensionDefinition.type,
            );
            if (isIncludeDimensionType && isValidDimensionType)
                dimensions.push(dimensionDefinition.id);
        }
    }
    return dimensions;
};

export const hasAdvertiser = (
    dimensionsSection: DimensionTemplates[][],
): boolean => {
    for (const section of dimensionsSection) {
        for (const dimensionDefinition of section) {
            const dropdownConfiguration =
                dimensionDefinition.configuration as DropdownDimensionConfiguration;
            if (
                dropdownConfiguration.itemMapper?.value === ADVERTISER_ID_COLUMN
            ) {
                return true;
            }
        }
    }
    return false;
};

export const getUsedDimensionSections = (
    dimensionSection: DimensionTemplates[][],
    skippedDimensions: string[],
): DimensionTemplates[][] => {
    const usedDimensionSections: DimensionTemplates[][] = [];
    for (const section of dimensionSection) {
        const template: DimensionTemplates[] = section.filter(
            (dimensionSection) =>
                !skippedDimensions.includes(dimensionSection.id),
        );
        if (!isEmpty(template)) usedDimensionSections.push(template);
    }
    return usedDimensionSections;
};
